package io.github.kingsword09.symbolcraft.symbols.icons.materialsymbols.icons

import androidx.compose.ui.graphics.Color
import androidx.compose.ui.graphics.PathFillType.Companion.NonZero
import androidx.compose.ui.graphics.SolidColor
import androidx.compose.ui.graphics.StrokeCap.Companion.Butt
import androidx.compose.ui.graphics.StrokeJoin.Companion.Miter
import androidx.compose.ui.graphics.vector.ImageVector
import androidx.compose.ui.graphics.vector.ImageVector.Builder
import androidx.compose.ui.graphics.vector.path
import androidx.compose.ui.unit.dp
import io.github.kingsword09.symbolcraft.symbols.icons.materialsymbols.Icons

public val Icons.SortW500Rounded: ImageVector
    get() {
        if (_sortW500Rounded != null) {
            return _sortW500Rounded!!
        }
        _sortW500Rounded = Builder(name = "SortW500Rounded", defaultWidth = 24.0.dp, defaultHeight = 24.0.dp, viewportWidth = 960.0f, viewportHeight = 960.0f).apply {
            path(fill = SolidColor(Color(0xFF000000)), stroke = null, strokeLineWidth = 0.0f, strokeLineCap = Butt, strokeLineJoin = Miter, strokeLineMiter = 4.0f, pathFillType = NonZero) {
                moveTo(157.13f, 736.26f)
                quadToRelative(-19.24f, 0.0f, -32.25f, -13.17f)
                quadToRelative(-13.01f, -13.18f, -13.01f, -32.39f)
                reflectiveQuadToRelative(13.01f, -32.2f)
                quadToRelative(13.01f, -13.0f, 32.25f, -13.0f)
                lineTo(318.8f, 645.5f)
                quadToRelative(19.24f, 0.0f, 32.25f, 13.17f)
                quadToRelative(13.02f, 13.18f, 13.02f, 32.39f)
                reflectiveQuadToRelative(-13.02f, 32.21f)
                quadToRelative(-13.01f, 12.99f, -32.25f, 12.99f)
                lineTo(157.13f, 736.26f)
                close()
                moveTo(157.13f, 525.5f)
                quadToRelative(-19.24f, 0.0f, -32.25f, -13.17f)
                quadToRelative(-13.01f, -13.18f, -13.01f, -32.39f)
                reflectiveQuadToRelative(13.01f, -32.21f)
                quadToRelative(13.01f, -12.99f, 32.25f, -12.99f)
                horizontalLineToRelative(403.59f)
                quadToRelative(19.23f, 0.0f, 32.25f, 13.17f)
                quadToRelative(13.01f, 13.18f, 13.01f, 32.39f)
                reflectiveQuadToRelative(-13.01f, 32.2f)
                quadToRelative(-13.02f, 13.0f, -32.25f, 13.0f)
                lineTo(157.13f, 525.5f)
                close()
                moveTo(157.13f, 314.74f)
                quadToRelative(-19.24f, 0.0f, -32.25f, -13.17f)
                quadToRelative(-13.01f, -13.18f, -13.01f, -32.39f)
                reflectiveQuadToRelative(13.17f, -32.21f)
                quadToRelative(13.18f, -12.99f, 32.33f, -12.99f)
                horizontalLineToRelative(645.5f)
                quadToRelative(19.24f, 0.0f, 32.25f, 13.17f)
                quadToRelative(13.01f, 13.18f, 13.01f, 32.39f)
                reflectiveQuadToRelative(-13.17f, 32.2f)
                quadToRelative(-13.18f, 13.0f, -32.33f, 13.0f)
                horizontalLineToRelative(-645.5f)
                close()
            }
        }
        .build()
        return _sortW500Rounded!!
    }

private var _sortW500Rounded: ImageVector? = null
